import React from "react";

const tracksData = [
  {
    trackTitle: "Artificial Intelligence and Machine Learning",
    content: [
      "Advances in AI and ML algorithms",
      "Reinforcement learning",
      "Neural networks",
      "Deep learning models",
      "Applications of AI/ML in robotics, natural language processing, and computer vision",
    ],
  },
  {
    trackTitle: "Digital Security, Information Privacy and Web Technology",
    content: [
      "Enhancements in web security frameworks",
      "Data privacy policies",
      "Encryption techniques",
      "Identity management",
      "Safeguarding digital communications",
    ],
  },
  {
    trackTitle: "Internet of Everything and Sensor Networks",
    content: [
      "Integration of IoT systems with sensor networks",
      "Security issues",
      "Smart environments",
      "Communication protocols enabling sensor-based ecosystems",
    ],
  },
  {
    trackTitle: "Healthcare Analytics, CoVID-19 Technologies and Data Analysis",
    content: [
      "Use of data analytics in healthcare",
      "Predictive models",
      "CoVID-19 related innovations",
      "Healthcare data privacy",
      "Impact of AI in healthcare decision-making processes",
    ],
  },
  {
    trackTitle: "Software Engineering and Cloud Computing",
    content: [
      "Innovations in software development methodologies",
      "Agile and DevOps practices",
      "Advancements in cloud platforms",
      "Cloud-native architectures",
      "Service-oriented computing",
    ],
  },
  {
    trackTitle: "Digital Image and Video Processing",
    content: [
      "Image recognition",
      "Video analytics",
      "Computer vision advancements",
      "Pattern recognition",
      "Processing algorithms applied in various fields",
    ],
  },
  {
    trackTitle: "Circuits and Systems and Quantum Computing",
    content: [
      "Development of advanced circuit designs",
      "VLSI (Very-Large-Scale Integration)",
      "Quantum computing principles and algorithms",
      "Applications in cryptography and communication",
    ],
  },
  {
    trackTitle: "Communication Technologies",
    content: [
      "Recent trends in 5G/6G",
      "Satellite communications",
      "Wireless and optical communication",
      "Advancements in network protocols",
    ],
  },
  {
    trackTitle: "E-Commerce and E-Governance",
    content: [
      "Emerging trends in digital transactions",
      "Blockchain applications in governance",
      "Secure payment systems",
      "Public policy implications of digital governance",
    ],
  },
];

const Tracks = () => {
  return (
    <div className="pt-2 pb-4">
      <div className="container my-5 py-3">
      <div class="sec-title3 text-center">
            <span>Tracks</span>
            <h2>Key Tracks</h2>
          </div>
        <div className="accordion" id="tracksAccordion">
          {tracksData.map((track, index) => (
            <div className="accordion-item" key={index}>
              <h2 className="accordion-header" id={`heading${index}`}>
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse${index}`}
                  aria-expanded="false"
                  aria-controls={`collapse${index}`}
                >
                  {track.trackTitle}
                </button>
              </h2>
              <div
                id={`collapse${index}`}
                className="accordion-collapse collapse"
                aria-labelledby={`heading${index}`}
                data-bs-parent="#tracksAccordion"
              >
                <div className="accordion-body">
                  <ul>
                    {track.content.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Tracks;
